const AMPLITUDE_EVENT_NAMES = {
  BROWSE_SHOW_VIEW: 'Browse - Show View',
  CATEGORY_SET: 'Category - Set',
  EVENT_CREATED: 'Event Created',
  EVENT_DELETED: 'Event Deleted',
  EVENT_DETAIL_FETCH: 'Event Detail - Fetch',
  EVENT_UPDATED: 'Event Updated',
  SIGN_IN_SHOW_FORM: 'Sign In - Show Form',
  SIGN_IN_SUBMIT: 'Sign In - Submit',
  SIGN_IN_SUCCESS: 'Sign In - Success',
  SIGN_IN_FAILURE: 'Sign In - Failure',
  SIGN_UP_SHOW_FORM: 'Sign Up - Show Form',
  SIGN_UP_SUBMIT: 'Sign Up - Submit',
  SIGN_UP_SUCCESS: 'Sign Up - Success',
  SIGN_UP_FAILURE: 'Sign Up - Failure',
};

export default AMPLITUDE_EVENT_NAMES;



// WEBPACK FOOTER //
// ./src/amplitude/constants.js